<template>
	<div class="tab-list-wrapper">
		<header class="tab-header-wrapper">
			<ul class="tab-head-list">
				<FlipButton
					class="tab-head"
					v-for="(tab, index) in tabs"
					:key="index"
					:active="index === activeIndex"
					:action="() => setTab(index)"
				>
					<div class="tab-label">
						<slot name="tab-label" v-bind="tab"></slot>
					</div>
				</FlipButton>
			</ul>
			<slot name="tab-header"></slot>
		</header>
		<main class="card-body">
			<slot name="tab-body" v-bind="activeTab"></slot>
		</main>
  </div>
</template>

<script>

import FlipButton from '@/components/base/FlipButton';

export default {
	name: 'TabList',
	components: {
		FlipButton,
	},
	props: {
		initialIndex: {
			required: false,
			default: 0,
		},
		tabs: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			activeIndex: 0,
		};
	},
	computed: {
		activeTab() {
			return this.tabs[this.activeIndex];
		},
	},
	methods: {
		setTab(index) {
			this.activeIndex = index;
			this.$emit("change", this.activeTab);
		},
	},
	mounted() {
		this.setTab(this.initialIndex);
	},
};
</script>

<style lang="scss" scoped>
	.card-header {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
	}

	.tab-head-list {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: space-evenly;
		align-items: center;
		margin: 0 20px 20px;
		font-family: $heading-font;
		font-size: $font-size-md;
		letter-spacing: $letter-spacing-plus;

		@include desktop { margin: 20px; }
	}

	.card-body {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
</style>
